module.exports = __webpack_public_path__ + "public/images/learnerCommunityGalleryPreview.ccab145344ba016ae9c5ca7964a54d11.png";